/* eslint-disable react/function-component-definition */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable no-nested-ternary */
import axios from "axios";
import React, {
  useContext,
  useEffect,
  useState,
  useRef,
  Suspense,
  lazy,
} from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import PropTypes, { bool } from "prop-types";
import { useNavigate, useParams } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { TableContext } from "../../contexts/tableContext";
// import { SpinnerRoundFilled } from 'spinners-react';
import ActionButtons from "../ActionsButtons/ActionButtons";
import EmptyState from "../EmptyState/EmptyState";
import Pagination from "../Pagination/Pagination";
import { tabledelete } from "../../redux/TableDeleteSlice";
import ToggleButtonOnOff from "../ToggleButton/ToggleButton";
import toggleStyles from "../ToggleButton/ToggleButton.module.scss";
// import ActionSelection from '../ActionsButtons/ActionSelection';
import styles from "./CustomTable.module.scss";
import "react-confirm-alert/src/react-confirm-alert.css";
import { getCookies, getPermissions } from "../../hooks/useCookies";
import { DateFormatter } from "../../utilityFunctions/utilsFunctions";
import { SpinnerCircularFixed } from "spinners-react";
import { NumFormatter } from "../../utilityFunctions/utilsFunctions";
import { Image, Badge } from "react-bootstrap";
import { Entry } from "../../redux/entrySlice";
import { toast } from "react-toastify";
import useToggle from "../../hooks/useToggle";
import envValues from "../../enviornment";
import CreateVendorPopup from "../../pages/vendors/createVendorPopUp";
import CreateAdminUserPopup from "../../pages/adminusers/createUserPopUp";
import CreateCafePopup from "../../pages/cafes/createCafePopUp";
import CreateDrinkPopup from "../../pages/drinktypes/createDrinkPopUp";
import CreateMenuPopup from "../../pages/menus/createMenuPopup";
import { REACT_APP_API_FETCH_CLAIM_REQUESTS, REACT_APP_API_FEEDBACK_RESOLVE, REACT_APP_API_ISSUE_RESOLVE } from "../../redux/apiConstants";
import CreateCouponPopup from "../../pages/coupons/createCouponPopup";
import CreateCategoryPopup from "../../pages/category/createCategoryPopUp";
import Loader from "../Loader/Loader";
import ViewTicketPopup from "../../pages/tickets/viewTicketPopup";
import ViewSuggestionPopup from "../../pages/suggestions/viewSuggestionPopup";
import ViewPayoutPopup from "../../pages/payoutRequests/viewPayoutReqPopup";
import ViewIssuePopup from "../../pages/issues/viewIssuePopup";
import ViewFeedbackPopup from "../../pages/feedback/viewFeedbackPopup";
import CoffeeRewardPopup from "../../pages/coffeeCredits/viewCoffeeRewardPopup";
import OrdersPopup from "../../pages/orders/ordersPopup";
import ViewOrderDetailsPopup from "../../pages/orders/ViewOrderDetailsPopup";
import CafeImportModal from "../../pages/cafes/CafeImportModal";
import CafeExportModal from "../../pages/cafes/CafeExportModal";
import UserExportModal from "../../pages/users/UserExportModal";
import VendorExportModal from "../../pages/vendors/VendorExportModal";

const Counter = lazy(() => import("../../components/Counter/Counter"));

const CustomTable = React.memo(
  ({
    urlParam,
    viewPopUp,
    paramId,
    toggleButton,
    section,
    deleteCondition,
    posConnected,
    edit = false,
    claimPermission = false,
  }) => {
    let url;
    const { dashboardStyle, card1bgStyle, card2bgStyle, card3bgStyle } =
      useContext(TableContext);
    const navigate = useNavigate();
    const { bodyStyle } = useContext(TableContext);
    const [addButtonPermissions, setAddButtonPermissions] = useState({});
    const { bodyheader } = useContext(TableContext);
    const { setDashboardHeader } = useContext(TableContext);
    const { searchboxStyle } = useContext(TableContext);
    const { dashUpdate, setDashUpdate } = useContext(TableContext);
    const { tableheadStyle } = useContext(TableContext);
    const { tablebodyStyle } = useContext(TableContext);
    const { actionbtnStyle } = useContext(TableContext);
    const { claimUpdate, setClaimUpdate, actionReject } =
      useContext(TableContext);
    const [tableData, setTableData] = useState([]);
    const [cafeStatus, setCafeStatus] = useState(
      () => new URLSearchParams(window.location.search).get("statusBy") || ""
    );
    const [showTablePopUp, setShowTablePopUp] = useToggle();
    const listRequestRef = useRef(0);
    const listAbortRef = useRef(null);

    const dispatch = useDispatch();
    // const { pageNum, setPageNum } = useContext(TableContext);
    // new
    const [pageNum, setPageNum] = useState(1);
    const tablelength = 0;
    const [checkedState, setCheckedState] = useState(
      new Array(tablelength).fill(false)
    );
    const [checkedAll, setCheckedAll] = useState(false);
    const token = `Bearer ${getCookies("Token")}`;
    const dateFormat = getCookies("dateFormat");
    const [sorting, setSorting] = useState([{ col: "none", sortType: "none" }]);
    const [paginationData, setPaginationData] = useState([
      { page: 0, totalResult: 0, totalPages: 0 },
    ]);
    const [search, setSearchTerm] = useState(null);
    const [timer, setTimer] = useState(null);
    const [columns, setColumns] = useState([]);
    const [deletedData, setDeletedData] = useState(null);
    const [selected, setselected] = useState([]);
    const [tableLoading, setTableLoading] = useState(true);
    const [totalResults, setTotalResults] = useState(null);
    const [canDelete, setCanDelete] = useState(true);
    const [pendingCount, setPendingCount] = useState(0);
    const [searchState, setSearchState] = useState(false);
    const [isUpdated, setIsUpdated] = useState(false);
    const params = useParams();
    const [claimCafeId, setClaimCafeId] = useState(null);
    const [action, setAction] = useState("view");
    const [actionPermissions, setActionPermission] = useState({});
    const [editItem, setEditItem] = useState();
    const [showImportModal, setShowImportModal] = useState(false);
    const [showExportModal, setShowExportModal] = useState(false);
    const [showUserExportModal, setShowUserExportModal] = useState(false);
    const [showVendorExportModal, setShowVendorExportModal] = useState(false);
    const [showOrderDetailsPopup, setShowOrderDetailsPopup] = useState(false);
    const [selectedOrderId, setSelectedOrderId] = useState(null);
    const [updatingStock, setUpdatingStock] = useState(new Set());
    const [updatingSync, setUpdatingSync] = useState(new Set());

    const handleToggleMenuStock = (menuId, inStock) => {
      setUpdatingStock((prev) => new Set(prev).add(menuId));
      axios
        .patch(
          `${envValues.REACT_APP_API_ENDPOINT}/menus/${menuId}/toggle-menu-stock`,
          { inStock },
          { headers: { Authorization: token } }
        )
        .then((resp) => {
          if (resp.status === 200) {
            toast.success(inStock ? "Item marked in stock" : "Item marked out of stock");
            setTableData((prev) =>
              prev.map((item) =>
                item.id === menuId ? { ...item, isOutOfStock: !inStock } : item
              )
            );
          } else {
            toast.error("Failed to update stock");
          }
        })
        .catch(() => {
          toast.error("Failed to update stock");
        })
        .finally(() => {
          setUpdatingStock((prev) => {
            const next = new Set(prev);
            next.delete(menuId);
            return next;
          });
        });
    };

    const handleToggleMenuSync = (menuId, isSyncDisabled) => {
      setUpdatingSync((prev) => new Set(prev).add(menuId));
      axios
        .patch(
          `${envValues.REACT_APP_API_ENDPOINT}/menus/${menuId}/toggle-menu-sync`,
          { isSyncDisabled },
          { headers: { Authorization: token } }
        )
        .then((resp) => {
          if (resp.status === 200) {
            toast.success(isSyncDisabled ? "Sync disabled for this item" : "Sync enabled for this item");
            setTableData((prev) =>
              prev.map((item) =>
                item.id === menuId ? { ...item, isSyncDisabled } : item
              )
            );
          } else {
            toast.error("Failed to update sync setting");
          }
        })
        .catch(() => {
          toast.error("Failed to update sync setting");
        })
        .finally(() => {
          setUpdatingSync((prev) => {
            const next = new Set(prev);
            next.delete(menuId);
            return next;
          });
        });
    };

    // const dataPerPage = section === "Menus" ? 1000 : 5;
    console.log("Section==", section);
    const dataPerPage = ["Tickets"].includes(section)
      ? 20
      : ["coupons", "Coffee Credits"].includes(section)
      ? 10
      : 5;
    let response;
    let statusCode;
    const handleOnChange = (id, position) => {
      // eslint-disable-next-line max-len
      // eslint-disable-next-line max-len
      const updatedCheckedState = checkedState.map((item, indexed) =>
        indexed === position ? !item : item
      );
      setCheckedState(updatedCheckedState);
      setselected((oldArray) => [...oldArray, id]);
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i <= checkedState.length; i++) {
        if (checkedState[position] === true) {
          // eslint-disable-next-line no-plusplus
          for (let j = 0; j < selected.length; j++) {
            if (selected[j] === id) {
              selected.splice(j, 1);
            }
            // const newselected = selected.filter((item) => item === id);
            // setselected(newselected);
          }
        }
      }
    };

    const capitalizeWords = (sentence) => {
      return sentence
        .split(" ")
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        )
        .join(" ");
    };

    const actionAdd = () => {
      console.log("section----", section);
      if (section === "Menus" || section === "coupons") {
        setShowTablePopUp(true);
        // navigate(`/${section.toLowerCase()}/create/${paramId}`);
      } else if (
        section === "Vendor" ||
        section === "Adminuser" ||
        section === "Cafe" ||
        section === "drinktypes" ||
        section === "category" ||
        section === "Menus"
      ) {
        setShowTablePopUp(true);
      } else {
        // setShowTablePopUp(true);
        navigate(`/${section.toLowerCase()}/create/`);
      }
    };

    const handleOnChangeAll = () => {
      setCheckedAll(!checkedAll);
      const newarray = [];
      if (checkedAll === false) {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < tableData.length; i++) {
          newarray.push(tableData[i].id);
          checkedState[i] = true;
        }
        setselected(newarray);
      } else {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < tableData.length; i++) {
          checkedState[i] = false;
        }
        setselected([]);
      }
    };

    const getUsers = async () => {
      const requestId = ++listRequestRef.current;
      if (listAbortRef.current) {
        listAbortRef.current.abort();
      }
      const controller = new AbortController();
      listAbortRef.current = controller;
      setTableLoading(true);
      url = urlParam;
      url += `page=${pageNum}&limit=${dataPerPage}`;
      if (sorting.sortType && sorting.sortType !== "none") {
        url += `&sortBy=${sorting.col}:${sorting.sortType}`;
      }
      if (search !== null) {
        url += `&searchBy=${search}`;
        setSearchState(true);
      } else {
        setSearchState(false);
      }
      if (
        cafeStatus !== "" &&
        (section === "Cafe" ||
          section === "payoutrequests" ||
          section === "Tickets")
      ) {
        url += `&statusBy=${cafeStatus}`;
      }
      console.log(url);
      axios
        .get(url, {
          method: "GET",
          headers: { Authorization: token },
          signal: controller.signal,
        })
        .then((resp) => {
          if (requestId !== listRequestRef.current) return null;
          setTableLoading(false);
          statusCode = resp.status;
          return resp;
        })
        .then((res) => {
          if (!res || requestId !== listRequestRef.current) return;
          if (statusCode === 200 || statusCode === 201) {
            console.log("res", res);
            response = res.data.data.result;
            console.log("custom table response---", response);
            setTableData(response.results);
            setClaimCafeId(response.claimCafeId ?? null);
            setPendingCount(response.pendingCount);
            setPaginationData({
              page: response.page,
              totalResult: response.totalResults,
              totalPages: response.totalPages,
            });
            setTotalResults(response?.totalResults);
            if (
              response?.totalResults === 0 ||
              response?.results.length === 0
            ) {
              setColumns([]);
            } else {
              setColumns(response?.Displayfields);
            }
          }
        })
        .catch((err) => {
          if (
            axios.isCancel(err) ||
            requestId !== listRequestRef.current
          ) {
            return err;
          }
          setTableLoading(false);
          console.log("error:", err);
          if (err.response?.status === 404) {
            console.log("axios errors");
            setColumns([]);
            setTableData([]);
          }
          return err;
        });
    };

    const location = useLocation();

    useEffect(() => {
      const params = new URLSearchParams(location.search);
      const query = params.get("statusBy");
      if (!query) return;
      setCafeStatus(query);
      params.delete("statusBy");
      navigate(
        { pathname: location.pathname, search: params.toString() },
        { replace: true }
      );
    }, [location, navigate]);

    useEffect(() => {
      setSearchTerm(null);
      setPageNum(1);
    }, [cafeStatus]);

    useEffect(() => {
      setDashboardHeader(
        section === "payouts"
          ? "Payouts"
          : section === "payoutrequests"
          ? "Payout Requests"
          : section === "Adminuser"
          ? "Admin Users"
          : section === "drinktypes"
          ? "Drink Types"
          : section === "claimrequests"
          ? "Cafe Claim Requests"
          : section === "enquiries"
          ? "enquiries"
          : section === "Menus"
          ? "Cafe"
          : section === "coupons"
          ? "Coupons"
          : section === "Issues"
          ? "Issues & Support"
          : section === "claimRequestDetails"
          ? "Cafe Claim Requests"
          : section === "Tickets"
          ? "Vendor Support Tickets"
          : section === "category"
          ? "Category"
          : section === "participationRequests"
          ? "Participation Requests"
          : section === "suggestions"
          ? "Suggested Cafes"
          : section === "suggestedEdits"
          ? "Suggested Edits"
          : section === "mergerequests"
          ? "Merge Requests"
          : section === "VendorApplications"
          ? "Vendor Applications"
          : section === "orderahead"
          ? "Order Ahead"
          : section === "campaignsupport"
          ? "Campaign Support"
          : section
      );
      const temp = section.replace(/\s+/g, "").toLowerCase();
      const permissions = getPermissions();
      console.log("permissions", permissions);
      permissions.forEach((val) => {
        if (val.section.toLowerCase() === temp) {
          setAddButtonPermissions({
            view: val.view ? val.view : false,
            edit: val.edit ? val.edit : false,
            create: val.create ? val.create : false,
            delete: val.delete ? val.delete : false,
            list: !!(val.view || val.edit || val.create || val.delete),
          });
        } else if (val.submenu) {
          val.submenu.forEach((element) => {
            if (element.section.toLowerCase() === temp) {
              setAddButtonPermissions({
                view: element.view ? element.view : false,
                edit: element.edit ? element.edit : false,
                create: element.create ? element.create : false,
                delete: element.delete ? element.delete : false,
                list: !!(
                  element.view ||
                  element.edit ||
                  element.create ||
                  element.delete
                ),
              });
            }
          });
        }
      });
      getUsers();
      const newarray = [];
      if (checkedAll) {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < tableData.length; i++) {
          newarray.push(tableData[i].id);
          checkedState[i] = true;
        }
        setselected(newarray);
      } else {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < tableData.length; i++) {
          checkedState[i] = false;
        }
        setselected([]);
      }
      if (isUpdated) {
        setIsUpdated(false);
      }
      if (claimUpdate) {
        setClaimUpdate(false);
      }
      return () => {
        listAbortRef.current?.abort();
      };
    }, [
      pageNum,
      search,
      actionReject,
      cafeStatus,
      isUpdated,
      claimUpdate,
    ]);

    const setSort = (param) => () => {
      setPageNum(1);
      switch (sorting.sortType) {
        case "none":
          setSorting({ col: param, sortType: "asc" });
          break;
        case "asc":
          setSorting({ col: param, sortType: "desc" });
          break;
        case "desc":
          setSorting({ col: param, sortType: "none" });
          break;
        default:
          setSorting({ col: param, sortType: "asc" });
          break;
      }
    };
    const onFilterTextChange = (e) => {
      const even = e;
      if (timer) {
        clearTimeout(timer);
        setTimer(null);
      }
      setTimer(
        setTimeout(() => {
          const { value } = even.target;
          if (value.length > 0) {
            setPageNum(1);
            setSearchTerm(value.trimStart());
          } else {
            setSearchTerm(null);
            setSearchState(false);
          }
        }, 1000)
      );
    };

    const actionView = (param) => {
      console.log(section, "param");
      const encodeText = param;
      if (viewPopUp) {
        setShowTablePopUp(true);
      } else if (section !== "Notifications")
        navigate(`/${section}/viewdetails/${encodeText}`);
      else if (section === "Menus") {
        navigate(`/${section.toLowerCase()}/menu-details/${paramId}`);
      }
    };

    const handleClaimApprove = (id) => {
      console.log("approve id", claimCafeId);
      let data = {};

      confirmAlert({
        title: canDelete ? "" : "Oops!!",
        message: "Are you sure you want to approve?",
        buttons: canDelete
          ? [
              {
                label: "Yes",
                onClick: () => {
                  const actionUrl = ` ${REACT_APP_API_FETCH_CLAIM_REQUESTS}/approve/${id} `;
                  const actionData = { cafeId: claimCafeId };
                  axios
                    .post(actionUrl, actionData, {
                      headers: { Authorization: token },
                    })
                    .then((resp) => {
                      if (resp.status === 200) {
                        console.log("response-->", resp.data);
                        toast.success("Claim Request approved successfully");
                        if (!claimUpdate) setClaimUpdate(true);
                        setShowTablePopUp(false);
                        setDashUpdate((prevDashUpdate) => !prevDashUpdate);
                        setIsUpdated(true);
                      } else {
                        toast.error("Error approving Claim Request");
                      }
                    })
                    .catch((err) => {
                      toast.error("Error approving Claim Request");
                      console.error("Error: ", err);
                    });
                },
              },
              {
                label: "No",
                // onClick: () => alert("Click No")
              },
            ]
          : [
              {
                label: "Ok",
                // onClick: () => alert("Click No")
              },
            ],
      });
    };

    const handleClaimReject = (id) => {
      confirmAlert({
        title: canDelete ? "" : "Oops!!",
        message: "Are you sure you want to reject?",
        buttons: canDelete
          ? [
              {
                label: "Yes",
                onClick: () => {
                  console.log("ids:", id, "sldfj:", claimCafeId);
                  const actionUrl = ` ${REACT_APP_API_FETCH_CLAIM_REQUESTS}/reject/${id} `;
                  const actionData = { cafeId: claimCafeId };
                  axios
                    .post(actionUrl, actionData, {
                      headers: { Authorization: token },
                    })
                    .then((resp) => {
                      if (resp.status === 200) {
                        console.log("response-->", resp.data);
                        toast.success("Claim Request rejected successfully");
                        setShowTablePopUp(false);
                        if (!claimUpdate) setClaimUpdate(true);
                        setDashUpdate((prevDashUpdate) => !prevDashUpdate);
                        setIsUpdated(true);
                      } else {
                        toast.error("Error rejecting Claim Request");
                      }
                    })
                    .catch((err) => {
                      toast.error("Error rejecting Claim Request");
                      console.error("Error: ", err);
                    });
                },
              },
              {
                label: "No",
                // onClick: () => alert("Click No")
              },
            ]
          : [
              {
                label: "Ok",
                // onClick: () => alert("Click No")
              },
            ],
      });
    };

    const handleMarkAsResolved = (itemId,section) => {
      const titleCase = s => s.replace(/\w\S*/g, w => w[0].toUpperCase() + w.slice(1).toLowerCase());
      let actionUrl = `${REACT_APP_API_FEEDBACK_RESOLVE}/${itemId}/resolve`;
      if(section==="Issues"){
         actionUrl = `${REACT_APP_API_ISSUE_RESOLVE}/${itemId}/resolve`;
      }
      // else if(section==="Tickets"){
      //   actionUrl = `${REACT_APP_API_TICKET_RESOLVE}/${itemId}/resolve`;
      // }
      confirmAlert({
        title: "",
        message: `Do you want to mark this ${section.toLowerCase()} as resolved?`,
        buttons: [
          {
            label: "Yes",
            onClick: () => {
              axios
                .patch(actionUrl, {}, {
                  headers: { Authorization: token },
                })
                .then((resp) => {
                  if (resp.status === 200) {
                    toast.success(`${titleCase(section)} marked as resolved successfully`);
                    setIsUpdated(true);
                  } else {
                    toast.error(`Error marking ${section.toLowerCase()} as resolved`);
                  }
                })
                .catch((err) => {
                  toast.error(err.response?.data?.message || `Error marking ${section.toLowerCase()} as resolved`);
                  console.error("Error: ", err);
                });
            },
          },
          {
            label: "No",
          },
        ],
      });
    };

    const applyFilter = (status) => {
      setCafeStatus(status);
      setPageNum(1);
      setSearchTerm(null);
    };

    useEffect(() => {
      const temp = section.replace(/\s+/g, "").toLowerCase();
      const permissions = getPermissions();
      permissions.forEach((val) => {
        if (val.section.toLowerCase() === temp) {
          setActionPermission({
            view: val.view ? val.view : false,
            edit: val.edit ? val.edit : false,
            create: val.create ? val.create : false,
            delete: val.delete ? val.delete : false,
            approve: val.approve ? val.approve : false,
          });
        }
      });
      if (deleteCondition.checkCondition) {
        setCanDelete(false);
        setDeletemessage("Sorry you cant delete this data");
      }
    }, []);

    const actionEdit = (data) => {
      console.log("data ==", data);
      setAction("edit"); // Set action to "edit"
      setEditItem(data);
      const encodeText = data.id;
      // if (viewPopUp) {
      setShowTablePopUp(true);
      // } else {
      //   navigate(`/${section}/editdetails/${encodeText}`);
      // }
    };

    const hasTableData = Object.keys(tableData)?.length > 0;
    const isTableEmpty = !tableLoading && !hasTableData;
    const showListToolbar = section !== "claimRequestDetails";

    return (
      <div className={styles[bodyStyle]}>
        {(addButtonPermissions.list ||
          section === "Menus" ||
          section === "claimRequestDetails" ||
          section === "mergerequests") && (
          <div
            className={styles[dashboardStyle]}
            style={{ minHeight: section !== "Menus" ? "100vh" : null }}
            id={viewPopUp ? styles.dashboardcont3 : styles.dashboardcont2}
          >
            {/* {(section === "User" ||
              section === "Vendor" ||
              section === "Cafe") && (
                <Suspense
                  fallback={
                    <div>
                      <Loader
                        style={{
                          marginTop: "20px",
                          marginLeft: "120px",
                        }}
                      />
                    </div>
                  }
                >
                  <Counter
                    className={section === "User"
                      ? styles[card1bgStyle] // Replace with the appropriate icon for "User"
                      : section === "Vendor"
                        ? styles[card2bgStyle] // Replace with the appropriate icon for "User"
                        // Replace with the appropriate icon for "Vendor"
                        : section === "Cafe"
                          ? styles[card3bgStyle] // Replace with the appropriate icon for "User"
                          // Replace with the appropriate icon for "Cafe"
                          : styles[card1bgStyle] // Replace with the appropriate icon for "User"
                      // Default icon for "Total Results" or other sections
                    }
                    cardstyle={styles.cardbox1}
                    cardicon={
                      section === "User"
                        ? faUsers // Replace with the appropriate icon for "User"
                        : section === "Vendor"
                          ? faStore // Replace with the appropriate icon for "Vendor"
                          : section === "Cafe"
                            ? faCoffee // Replace with the appropriate icon for "Cafe"
                            : faBookOpenReader // Default icon for "Total Results" or other sections
                    }
                    text={
                      section === "User"
                        ? "Users"
                        : section === "Vendor"
                          ? "Vendors"
                          : section === "Cafe"
                            ? "Cafes"
                            : "Total Results"
                    }
                    count={NumFormatter(totalResults)}
                  />
                </Suspense>
              )} */}
            <div className="container-fluid" id={styles.container}>
              {showListToolbar && (
                <div
                  className="row"
                  style={{
                    marginTop:
                      section === "VendorApplications" || section === "orderahead"
                        ? "70px"
                        : "20px",
                  }}
                >
                      <div className="col-lg-4 col-md-12 col-sm-12">
                        <div className={styles.search_box}>
                          <input
                            className={styles[searchboxStyle]}
                            id={styles.searchbar}
                            type="search"
                            onChange={onFilterTextChange}
                            placeholder="Search"
                            readOnly={tableLoading}
                          />
                        </div>
                      </div>
                      <div
                        className={`col-lg-3 col-md-12 col-sm-12 ${styles.pendingmessage}`}
                      >
                        {pendingCount > 0 && actionPermissions.approve && (
                          <div
                            style={{
                              backgroundColor: "#FF5C00",
                              color: "white",
                              padding: "8px 12px",
                              cursor: "pointer",
                              borderRadius: "10px",
                              whiteSpace: "nowrap",
                              zIndex: 10,
                              position: "relative",
                              fontSize: "13px",
                            }}
                            onClick={() => applyFilter("Pending")}
                          >
                            {pendingCount} Cafes Pending, Click to review
                            <i
                              className="fa fa-chevron-right"
                              style={{ marginLeft: "5px" }}
                            ></i>
                          </div>
                        )}
                      </div>
                      <div className="col-lg-5 col-md-12 col-sm-12">
                        <div className={styles.sectionright}>
                      {addButtonPermissions.delete && selected.length > 0 && (
                        <div className="dropdown" id={styles.dropdown}>
                          <button
                            className="btn btn-secondary dropdown-toggle"
                            type="button"
                            id="dropdownMenuButton1"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            Actions
                          </button>
                          <ul
                            className="dropdown-menu"
                            id={styles.dropdown_menu}
                            aria-labelledby="dropdownMenuButton1"
                          >
                            <li>
                              <a
                                className="dropdown-item"
                                onClick={() => {
                                  confirmAlert({
                                    title: "",
                                    message: "Are you sure you want to delete?",
                                    buttons: [
                                      {
                                        label: "Yes",
                                        onClick: () => {
                                          dispatch(tabledelete(selected)).then(
                                            () => {
                                              setDeletedData(
                                                `data deleted ${selected}`
                                              );
                                              window.location.reload(false);
                                            }
                                          );
                                        },
                                      },
                                      {
                                        label: "No",
                                        // onClick: () => alert("Click No")
                                      },
                                    ],
                                  });
                                }}
                              >
                                Delete{" "}
                                <i
                                  className="fa fa-trash"
                                  aria-hidden="true"
                                  id={styles.del_icon}
                                />
                              </a>
                            </li>
                          </ul>
                        </div>
                      )}
                      {/* {addButtonPermissions.delete && (
                    <button
                      className={selected.length ? styles.tabledelbtn : 'disabled'}
                      type="button"
                      onClick={() => {
                        confirmAlert({
                          title: '',
                          message: 'Are you sure want to delete.',
                          buttons: [
                            {
                              label: 'Yes',
                              onClick: () => {
                                dispatch(tabledelete(selected)).then(() => {
                                  setDeletedData(`data deleted ${selected}`);
                                  window.location.reload(false);
                                });
                              },
                            },
                            {
                              label: 'No',
                              // onClick: () => alert("Click No")
                            },
                          ],
                        });
                      }}
                    >
                      <i className="fa fa-trash" aria-hidden="true" id={styles.del_icon} />
                    </button>
                  )} */}

                      {section === "Cafe" && (
                        <>
                          {/* <span>Filter</span> */}

                          <select
                            className={styles.filterDropdown}
                            onChange={(e) => applyFilter(e.target.value)}
                            value={cafeStatus}
                          >
                            <option value="">All</option>
                            <option value="Pending">Pending</option>
                            <option value="Rejected">Rejected</option>
                            <option value="Approved">Approved</option>
                            <option value="Claimed">Claimed</option>

                            <option value="Unclaimed">Unclaimed</option>
                            {/* Add more options as needed */}
                          </select>
                        </>
                      )}

                      {section === "Tickets" && (
                        <>
                          <select
                            className={styles.filterDropdown}
                            onChange={(e) => applyFilter(e.target.value)}
                            value={cafeStatus}
                          >
                            <option value="">All</option>
                            <option value="Open">Open</option>
                            <option value="Hold">Hold</option>
                            <option value="Closed">Closed</option>
                          </select>
                        </>
                      )}

                      {section === "payoutrequests" && (
                        <>
                          {/* <span>Filter</span> */}

                          <select
                            className={styles.filterDropdown}
                            onChange={(e) => applyFilter(e.target.value)}
                            value={cafeStatus}
                          >
                            <option value="">All</option>
                            <option value="Approved">Approved</option>
                            <option value="Rejected">Rejected</option>
                            <option value="Requested">Requested</option>
                          </select>
                        </>
                      )}
                      {addButtonPermissions.create &&
                        section !== "claimrequests" &&
                        section !== "User" &&
                        section !== "payouts" &&
                        section !== "enquiries" &&
                        section !== "campaignsupport" &&
                        section !== "Feedback" &&
                        section !== "Issues" &&
                        section !== "mergerequests" &&
                        !posConnected && (
                          <button
                            className={styles.tablebtn}
                            type="button"
                            onClick={() => {
                              actionAdd();
                            }}
                          >
                            {" "}
                            <FontAwesomeIcon
                              icon={faPlus}
                              className={styles.add_icon}
                            />
                            {"  "}
                            {section === "Menus"
                              ? "Add Menu"
                              : section === "Vendor"
                              ? "Add Vendor"
                              : section === "Adminuser"
                              ? "Add User"
                              : section === "User"
                              ? "Add User"
                              : section === "Cafe"
                              ? "Add Cafe"
                              : section === "drinktypes"
                              ? "Add Drink Type"
                              : section === "roles"
                              ? "Add Role"
                              : section === "category"
                              ? "Add Category"
                              : section === "coupons" && "Add Coupon"}
                          </button>
                        )}

                      {/* Import Cafes Button */}
                      {section === "Cafe" && actionPermissions.create && (
                        <button
                          className={styles.importBtn}
                          type="button"
                          onClick={() => setShowImportModal(true)}
                        >
                          <i className="fa fa-file-import" />
                          {"  "}Import Cafes
                        </button>
                      )}
                      {/* Export Cafes Button */}
                      {section === "Cafe" && (
                        <button
                          className={styles.importBtn}
                          type="button"
                          onClick={() => setShowExportModal(true)}
                          aria-label="Export Cafes"
                        >
                          <i className="fa fa-file-export" />
                          {"  "}Export Cafes
                        </button>
                      )}

                      {/* Export Users Button */}
                      {section === "User" && addButtonPermissions.list && (
                        <button
                          className={styles.importBtn}
                          type="button"
                          onClick={() => setShowUserExportModal(true)}
                          aria-label="Export Users"
                        >
                          <i className="fa fa-file-export" />
                          {"  "}Export Users
                        </button>
                      )}

                      {/* Export Vendors Button */}
                      {section === "Vendor" && addButtonPermissions.list && (
                        <button
                          className={styles.importBtn}
                          type="button"
                          onClick={() => setShowVendorExportModal(true)}
                          aria-label="Export Vendors"
                        >
                          <i className="fa fa-file-export" />
                          {"  "}Export Vendors
                        </button>
                      )}

                      {section === "Menus" && !posConnected && (
                        <button
                          className={styles.tablebtn}
                          type="button"
                          onClick={() => {
                            actionAdd();
                          }}
                        >
                          {" "}
                          <FontAwesomeIcon
                            icon={faPlus}
                            className={styles.add_icon}
                          />
                          {"  "}
                          {section === "Menus" && "Add Menu"}
                        </button>
                      )}
                        </div>
                      </div>
                    </div>
              )}

              <div
                className="table-responsive"
                style={{ minHeight: "250px", position: "relative" }}
              >
                  {tableLoading ? (
                    <Loader centered />
                  ) : isTableEmpty ? (
                    <EmptyState
                      section={section}
                      searchState={searchState}
                      cafeStatus={cafeStatus}
                      compact
                    />
                  ) : (
                  <table className="table table-borderless">
                    {columns?.length > 0 && (
                      <thead>
                        <tr className={styles[tableheadStyle]}>
                          {/* {addButtonPermissions.delete && (
                          <th scope="col">
                            <input
                              type="checkbox"
                              id="custom-checkbox"
                              // name={data.id}
                              // value={data.id}
                              checked={checkedAll}
                              onChange={() => handleOnChangeAll()}
                            />
                          </th>
                        )} */}
                          {columns.map((item) => (
                            <th scope="col">
                              {" "}
                              {item === "bankName"
                                ? "Bank Name"
                                : item === "bankAccountNumber"
                                ? "Account Number"
                                : item === "adminApproved"
                                ? "Admin Approved"
                                : item === "requestedTime"
                                ? "Requested Time"
                                : item === "requestDate"
                                ? "Requested Date"
                                : item === "location_name"
                                ? "Location"
                                : item === "claimrequests"
                                ? "Claim Requests"
                                : item === "totalEmployees"
                                ? "Total Employees"
                                : item === "totalRating"
                                ? "Toatal rating"
                                : item === "userType"
                                ? "User Type"
                                : item === "firstName"
                                ? "First Name"
                                : item === "lastName"
                                ? "Last Name"
                                : item === "payoutStatus"
                                ? "Payout Status"
                                : item === "amount" &&
                                  section === "payoutrequests"
                                ? "Requested Amount"
                                : item === "couponCode"
                                ? "Coupon Code"
                                : item === "lastReply"
                                ? "Last Replied"
                                : item === "cafeName"
                                ? "Cafe Name"
                                : item === "ownerName"
                                ? "Owner Name"
                                : item === "order_id"
                                ? "Order #"
                                : item === "latestSubmit"
                                ? "Latest Submitted"
                                : item === "applicationSubmittedAt"
                                ? "Application Submitted"
                                : item === "isForceUpdate"
                                ? "Force Update"
                                : item === "buildversion"
                                ? "Build Version"
                                : item === "appType"
                                ? "App Type"
                                : item === "topicLabel"
                                ? "Topic"
                                : item === "createdAt"
                                ? "Submitted"
                                : capitalizeWords(item)}
                              {/* <button
                              className={styles.sortbtn}
                              type="button"
                              aria-label="Sort button"
                              onClick={setSort(item)}
                            >
                              {sorting.sortType === "asc" &&
                              sorting.col === item ? (
                                <i className="fa fa-arrow-up" />
                              ) : sorting.sortType === "desc" &&
                                sorting.col === item ? (
                                <i className="fa fa-arrow-down" />
                              ) : (
                                <i className="fa fa-sort" />
                              )}
                            </button> */}
                            </th>
                          ))}
                          {(section === "Feedback"||section==="Issues") && (
                            <th scope="col">Status</th>
                          )}
                          {section === "Cafe" && (
                            <th scope="col">Insurance Status</th>
                          )}
                          {section === "Menus" && posConnected && (
                            <>
                              <th scope="col">Stock</th>
                              <th scope="col">
                                <span style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
                                  Skip Sync
                                  <FontAwesomeIcon
                                    icon={faInfoCircle}
                                    style={{ color: "#6c757d", cursor: "pointer", fontSize: "14px" }}
                                    aria-label="Skip Sync information"
                                    tabIndex={0}
                                    onMouseEnter={(e) => {
                                      const rect = e.currentTarget.getBoundingClientRect();
                                      const tooltip = document.getElementById("skip-sync-tooltip");
                                      if (!tooltip) return;
                                      tooltip.style.visibility = "visible";
                                      tooltip.style.opacity = "1";
                                      const tooltipHeight = tooltip.offsetHeight;
                                      tooltip.style.top = `${rect.top - tooltipHeight - 10}px`;
                                      tooltip.style.left = `${rect.left + rect.width / 2}px`;
                                    }}
                                    onMouseLeave={() => {
                                      const tooltip = document.getElementById("skip-sync-tooltip");
                                      if (!tooltip) return;
                                      tooltip.style.visibility = "hidden";
                                      tooltip.style.opacity = "0";
                                    }}
                                    onFocus={(e) => {
                                      const rect = e.currentTarget.getBoundingClientRect();
                                      const tooltip = document.getElementById("skip-sync-tooltip");
                                      if (!tooltip) return;
                                      tooltip.style.visibility = "visible";
                                      tooltip.style.opacity = "1";
                                      const tooltipHeight = tooltip.offsetHeight;
                                      tooltip.style.top = `${rect.top - tooltipHeight - 10}px`;
                                      tooltip.style.left = `${rect.left + rect.width / 2}px`;
                                    }}
                                    onBlur={() => {
                                      const tooltip = document.getElementById("skip-sync-tooltip");
                                      if (!tooltip) return;
                                      tooltip.style.visibility = "hidden";
                                      tooltip.style.opacity = "0";
                                    }}
                                  />
                                </span>
                              </th>
                            </>
                          )}
                          <th scope="col">Actions</th>
                        </tr>
                      </thead>
                    )}
                    {Object?.keys(tableData) && !tableLoading ? (
                      <tbody>
                        {tableData?.map((item, index) => (
                          <tr
                            className={styles[tablebodyStyle]}
                            style={
                              item?.cafeStatus === "Pending"
                                ? { backgroundColor: "#FFEBCC" }
                                : null
                            }
                          >
                            {/* {addButtonPermissions.delete && (
                            <th scope="row">
                              <div className="left-section">
                                <input
                                  type="checkbox"
                                  id={`custom-checkbox-${item}`}
                                  name={item.id}
                                  value={item.id}
                                  checked={checkedState[
                                  
                                  index]}
                                  onChange={() =>
                                    handleOnChange(item.id, index)
                                  }
                                />
                              </div>
                            </th>
                          )} */}
                            {columns?.map((ele) => (
                              <td
                                onClick={
                                  [
                                    "suggestions",
                                    "payouts",
                                   
                                    "Feedback",
                                    "Coffee Credits",
                                  ].includes(section)
                                    ? () => actionEdit(item)
                                    : undefined
                                }
                              >
                                {ele === toggleButton.field ? (
                                  <>
                                    <ToggleButtonOnOff
                                      value={item[ele]}
                                      id={item.id}
                                      placeholders={["Active", "Inactive"]}
                                      isDisabled={!edit} //|| posConnected
                                    />
                                  </>
                                ) : ele === "adminApproved" ? (
                                  <ToggleButtonOnOff
                                    value={item.adminApproved}
                                    id={item.id}
                                    placeholders={["Active", "Inactive"]}
                                    isDisabled={true}
                                  />
                                ) :
                                ele === "twoFactorEnabled" ? (
                                  item[ele] ? <span style={{ color: "green" }}>Enabled</span> : <span style={{ color: "red" }}>Disabled</span>
                                ) : typeof item[ele] === "boolean"&& ele !== "isForceUpdate" ? (
                                  <h6 className="order_date">
                                    {" "}
                                    String(item[ele])
                                  </h6>
                                ) : ele === "username" ? (
                                  item?.user?.name
                                ):ele==='email' ? (
                                  <a href={`mailto:${item?.userId?.email ?? item.email}`}>{item?.userId?.email ?? item.email}</a>
                                )
                                 : ele === "name" && section === "Tickets" ? (
                                  item?.user?.name
                                ) : ele === "cafeName" &&
                                  section === "suggestedEdits" ? (
                                  item?.cafe?.name
                                ) : ele === "posted date" ? (
                                  DateFormatter(
                                    item?.createdAt,
                                    dateFormat || "MonthDayYear"
                                  )
                                ) : ele === "requestedTime" ? (
                                  DateFormatter(
                                    item?.requestedTime,
                                    dateFormat || "MonthDayYear"
                                  )
                                ) : ele === "requestDate" ? (
                                  DateFormatter(
                                    item?.requestDate,
                                    dateFormat || "MonthDayYear"
                                  )
                                ) : ele === "requested date" ? (
                                  DateFormatter(
                                    item?.["requested date"] || item?.createdAt,
                                    dateFormat || "MonthDayYear"
                                  )
                                ) : ele === "applicationSubmittedAt" ? (
                                  DateFormatter(
                                    item?.applicationSubmittedAt,
                                    dateFormat || "MonthDayYear"
                                  )
                                ) : ele === "submitted at" ? (
                                  DateFormatter(
                                    item?.["submitted at"],
                                    dateFormat || "MonthDayYear"
                                  )
                                ) : ele === "latestSubmit" ? (
                                  DateFormatter(
                                    item?.latestSubmit,
                                    dateFormat || "MonthDayYear"
                                  )
                                ) : ele === "vendor " ? (
                                  item?.vendor?._id ? (
                                    item?.vendor?.name ? (
                                      item?.vendor?.name
                                    ) : (
                                      item?.vendor?.phone
                                    )
                                  ) : (
                                    <span style={{ color: "orange" }}>
                                      Not Claimed
                                    </span>
                                  )
                                ) : ele === "vendor name" ? (
                                  item?.userId?.name
                                ) : ele === "name" &&
                                  ["suggestions", "suggestedEdits"].includes(
                                    section
                                  ) ? (
                                  item?.user?.name ?? item.name
                                ) : ele==='suggested Date'&& section==="suggestions" ? (
                                  DateFormatter(
                                    item?.createdAt,
                                    dateFormat || "MonthDayYear"
                                  )
                                ) : 
                                ele === "name" ? (
                                  item?.userId?.name ?? item.name
                                ) : ele === "discount" ? (
                                  item.discount ? (
                                    `${item.discount}%`
                                  ) : (
                                    "-"
                                  )
                                ) : ele === "amount" ? (
                                  `$${item.amount}`
                                ) : ele === "email" ? (
                                  item?.userId?.email ?? item.email
                                ) : ele === "role" ? (
                                  item?.role?.name
                                ) : (ele === "order id"||ele === "order_id") ? (
                                  <span
                                    href="#"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();  
                                      setSelectedOrderId(item?.order_id || item?._id);
                                      setShowOrderDetailsPopup(true);
                                    }}
                                    onKeyDown={(e) => {
                                      if (e.key === "Enter" || e.key === " ") {
                                        e.preventDefault();
                                        e.stopPropagation();  
                                        setSelectedOrderId(item?.order_id || item?._id);
                                        setShowOrderDetailsPopup(true);
                                      }
                                    }}
                                    tabIndex={0}
                                    aria-label={`View order ${item?.order_id} details`}
                                    style={{ color: "#39979d", cursor: "pointer", textDecoration: "underline" }}
                                  >
                                    {item?.order_id}
                                  </span>
                                  ) : ele === "user name" ? (
                                  item?.user?.name
                                ) : ele === "phone" ? (
                                  item?.userId?.phone ?? item.phone
                                ) : ele === "Participation Requests" ? (
                                  item?.requestCount
                                ) : ele === "claimrequests" ? (
                                  <span>
                                    {item?.claimrequests || 0}
                                    {item?.claimrequests > 1 && (
                                      <span
                                        style={{
                                          marginLeft: "8px",
                                          padding: "2px 8px",
                                          borderRadius: "12px",
                                          fontSize: "11px",
                                          backgroundColor: "#ff9800",
                                          color: "#fff",
                                          fontWeight: "bold",
                                        }}
                                      >
                                        Multiple
                                      </span>
                                    )}
                                  </span>
                                ) : ele === "stockStatus" ? (
                                  item.isOutOfStock ? (
                                    <Badge bg="danger">Out of Stock</Badge>
                                  ) : (
                                    <Badge bg="success">In Stock</Badge>
                                  )
                                ) : ele === "image" ? (
                                  item[ele]?.length > 0 ? (
                                    <Image
                                      src={item[ele]}
                                      alt="logo"
                                      style={{
                                        width: "50px",
                                        height: "50px",
                                        objectFit: "cover",
                                      }}
                                    />
                                  ) : (
                                    "N/A"
                                  )
                                ):ele === "isForceUpdate" ? (
                                  item[ele] ? "Yes" : "No"
                                ) : ele === "createdAt" ? (
                                  item?.createdAt
                                    ? DateFormatter(
                                        item.createdAt,
                                        dateFormat || "MonthDayYear"
                                      )
                                    : "—"
                                ) : ele === "message" &&
                                  section === "campaignsupport" ? (
                                  item.message?.length > 80
                                    ? `${item.message.slice(0, 80)}…`
                                    : item.message || "—"
                                ) : (
                                  item[ele]
                                )}
                              </td>
                            ))}

                            {(section === "Feedback"||section==="Issues") && (
                              <td>
                                {item.status === "pending" ? (
                                  <button
                                    className={`${styles.actionbtn} btn btn-outline-success btn-sm mx-3`}
                                    onClick={() => handleMarkAsResolved(item.id,section)}
                                    type="button"
                                    aria-label={`Mark ${section.toLowerCase()} as resolved`}
                                  >
                                    <i className="fa fa-check-circle"></i>
                                    {"  "}Mark as Resolved
                                  </button>
                                ) : (
                                  <span
                                    style={{
                                      color: "green",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Resolved
                                  </span>
                                )}
                              </td>
                            )}

                            {section === "Cafe" && (
                              <td>
                                {item.insuranceReminderSent ? (
                                  <span
                                    style={{
                                      padding: "4px 10px",
                                      borderRadius: "12px",
                                      fontSize: "12px",
                                      fontWeight: "bold",
                                      backgroundColor: "#dc3545",
                                      color: "#fff",
                                    }}
                                  >
                                    Date Expired
                                  </span>
                                ) : (
                                  "-"
                                )}
                              </td>
                            )}

                            {section === "Menus" && posConnected && (
                              <>
                                <td>
                                  {updatingStock.has(item.id) ? (
                                    <SpinnerCircularFixed size={24} color="#39979d" />
                                  ) : (
                                    <div className="col">
                                      <label className={toggleStyles.switch}>
                                        <input
                                          type="checkbox"
                                          checked={!item.isOutOfStock}
                                          onClick={() =>
                                            handleToggleMenuStock(item.id, !!item.isOutOfStock)
                                          }
                                          aria-label={`Toggle stock for ${item.name}`}
                                        />
                                        <span className={toggleStyles.slider} />
                                      </label>
                                    </div>
                                  )}
                                </td>
                                <td>
                                  {updatingSync.has(item.id) ? (
                                    <SpinnerCircularFixed size={24} color="#39979d" />
                                  ) : (
                                    <div className="col">
                                      <label className={toggleStyles.switch}>
                                        <input
                                          type="checkbox"
                                          checked={item.isSyncDisabled || false}
                                          onClick={() =>
                                            handleToggleMenuSync(item.id, !item.isSyncDisabled)
                                          }
                                          aria-label={`Skip sync for ${item.name}`}
                                        />
                                        <span className={toggleStyles.slider} />
                                      </label>
                                    </div>
                                  )}
                                </td>
                              </>
                            )}

                            <td
                              className={`${styles.btnLayout} ${
                                section === "campaignsupport"
                                  ? styles.actionsCell
                                  : ""
                              }`}
                            >
                              <ActionButtons
                                data={item}
                                claimCafeId={claimCafeId}
                                viewPopUp={true}
                                section={section.toLowerCase()}
                                setTableData={setTableData}
                                setIsUpdated={setIsUpdated}
                                edit={edit}
                                status={item?.cafeStatus}
                                permission={addButtonPermissions.edit}
                                posConnected={posConnected}
                              />

                              {/* {section === "Cafe" && (
                              <span
                                style={{ cursor: "pointer" }}
                                className="py-3"
                                onClick={() => navigate(`/menu/${item.id}`)}
                              >
                                <button
                                  type="button"
                                  className={styles.tablebtn1}
                                >
                                  <FontAwesomeIcon
                                    icon={faReceipt}
                                    className={styles.add_icon}
                                  />
                                </button>
                              </span>
                            )} */}
                              {section === "claimRequestDetails" &&
                                claimPermission && (
                                  <div className={styles.cafeapproval}>
                                    <button
                                      className={`${styles.actionbtn} btn btn-outline-success btn-sm mx-3`}
                                      onClick={() =>
                                        handleClaimApprove(item.userId?.id)
                                      }
                                    >
                                      <i className="fa fa-check"></i>
                                    </button>
                                    <button
                                      className="btn btn-outline-danger btn-sm"
                                      onClick={() =>
                                        handleClaimReject(item.userId?.id)
                                      }
                                    >
                                      <i className="fa fa-times"></i>
                                    </button>
                                  </div>
                                )}

                              {/* {section === "Cafe" &&
                              item?.cafeStatus === "Pending" &&
                              addButtonPermissions.edit && (
                                <div>
                                 
                                  <button
                                    className={`${styles.actionbtn} btn btn-outline-success btn-sm mx-3`}
                                    onClick={() => handleApprove(item._id)}
                                  >
                                    <i className="fa fa-check"></i>
                                  </button>
                                  <button
                                    className="btn btn-outline-danger btn-sm"
                                    // id={styles.actionbtn}
                                    onClick={() => handleReject(item._id)}
                                  >
                                    <i className="fa fa-times"></i>
                                  </button>
                                </div>
                              )} */}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    ) : (
                      section !== "Menus"
                    )}
                    {/* {tableData.length === 0 && !tableLoading ? (
                    <h6 className={styles.norecord}>No record found</h6>
                  ) : (
                    ""
                  )} */}
                  </table>
                  )}
              </div>

              {!tableLoading && paginationData?.totalPages > 1 && (
                <Pagination
                  paginationData={paginationData}
                  setPageNum={setPageNum}
                  section={section.toLowerCase()}
                />
              )}
              <br />
              <br />
            </div>
          </div>
        )}
        {showTablePopUp &&
          (section === "Vendor" ? (
            <CreateVendorPopup
              handleClose={setShowTablePopUp}
              setIsUpdated={setIsUpdated}
            />
          ) : section === "Adminuser" ? (
            <CreateAdminUserPopup
              handleClose={setShowTablePopUp}
              setIsUpdated={setIsUpdated}
            />
          ) : section === "Cafe" ? (
            <CreateCafePopup
              handleClose={setShowTablePopUp}
              setIsUpdated={setIsUpdated}
            />
          ) : section === "drinktypes" ? (
            <CreateDrinkPopup
              handleClose={setShowTablePopUp}
              setIsUpdated={setIsUpdated}
            />
          ) : section === "Menus" ? (
            <CreateMenuPopup
              cafeId={paramId}
              handleClose={setShowTablePopUp}
              setIsUpdated={setIsUpdated}
            />
          ) : section === "coupons" ? (
            <CreateCouponPopup
              // cafeId={paramId}
              handleClose={setShowTablePopUp}
              setIsUpdated={setIsUpdated}
            />
          ) : section === "category" ? (
            <CreateCategoryPopup
              handleClose={setShowTablePopUp}
              setIsUpdated={setIsUpdated}
            />
          ) : null)}

        {showTablePopUp &&
          (section === "Tickets" && actionPermissions?.view ? (
            <ViewTicketPopup
              ticketId={editItem?.id}
              handleClose={setShowTablePopUp}
            />
          ) : section === "suggestions" && actionPermissions?.view ? (
            <ViewSuggestionPopup
              suggestionId={editItem?.id}
              handleClose={setShowTablePopUp}
            />
          ) : section === "payouts" && actionPermissions?.view ? (
            <ViewPayoutPopup
              payoutId={editItem.id}
              handleClose={setShowTablePopUp}
              setIsUpdated={setIsUpdated}
            />
          ) : section === "Issues" && actionPermissions?.view ? (
            <ViewIssuePopup
              data={editItem}
              issueId={editItem?.id || editItem?._id}
              handleClose={setShowTablePopUp}
              setIsUpdated={setIsUpdated}
            />
          ) : section === "Feedback" && actionPermissions?.view ? (
            <ViewFeedbackPopup
              feedbackId={editItem.id}
              handleClose={setShowTablePopUp}
              setIsUpdated={setIsUpdated}
            />
          ) : section === "Coffee Credits" && actionPermissions?.view ? (
            <CoffeeRewardPopup
              userDetails={editItem}
              handleClose={setShowTablePopUp}
              setIsUpdated={setIsUpdated}
            />
          ) : null)}

        {/* Cafe Import Modal */}
        {showImportModal && (
          <CafeImportModal
            show={showImportModal}
            handleClose={() => setShowImportModal(false)}
            onSuccess={() => {
              setShowImportModal(false);
              setIsUpdated(true);
              if (!dashUpdate) {
                setDashUpdate(true);
              }
            }}
          />
        )}

        {/* Cafe Export Modal */}
        {showExportModal && (
          <CafeExportModal
            show={showExportModal}
            handleClose={() => setShowExportModal(false)}
          />
        )}

        {/* User Export Modal */}
        {showUserExportModal && (
          <UserExportModal
            show={showUserExportModal}
            handleClose={() => setShowUserExportModal(false)}
            searchBy={search}
          />
        )}

        {/* Vendor Export Modal */}
        {showVendorExportModal && (
          <VendorExportModal
            show={showVendorExportModal}
            handleClose={() => setShowVendorExportModal(false)}
            searchBy={search}
          />
        )}

        {/* Order Details Popup */}
        {showOrderDetailsPopup && selectedOrderId && (
          <ViewOrderDetailsPopup
            orderId={selectedOrderId}
            handleClose={() => {
              setShowOrderDetailsPopup(false);
              setSelectedOrderId(null);
            }}
          />
        )}

        {/* Skip Sync Tooltip — fixed so it escapes all overflow:hidden parents */}
        <div
          id="skip-sync-tooltip"
          role="tooltip"
          style={{
            position: "fixed",
            visibility: "hidden",
            opacity: "0",
            transform: "translateX(-50%)",
            backgroundColor: "#333",
            color: "#fff",
            fontSize: "12px",
            fontWeight: "400",
            padding: "6px 10px",
            borderRadius: "6px",
            whiteSpace: "nowrap",
            zIndex: 99999,
            pointerEvents: "none",
            transition: "opacity 0.2s ease",
            boxShadow: "0 2px 8px rgba(0,0,0,0.25)",
          }}
        >
          When enabled, this item will be excluded from POS sync updates
          <span
            style={{
              position: "absolute",
              top: "100%",
              left: "50%",
              transform: "translateX(-50%)",
              borderWidth: "5px",
              borderStyle: "solid",
              borderColor: "#333 transparent transparent transparent",
            }}
          />
        </div>
      </div>
    );
  }
);
CustomTable.propTypes = {
  urlParam: PropTypes.string,
  viewPopUp: PropTypes.bool,
  toggleButton: PropTypes.oneOfType([PropTypes.object]),
  deleteCondition: PropTypes.oneOfType([PropTypes.object]),
  section: PropTypes.string,
};
CustomTable.defaultProps = {
  viewPopUp: false,
  toggleButton: { show: false, field: "none" },
  deleteCondition: { checkCondition: false, apiUrl: "none" },
  section: "User",
  urlParam: null,
};
export default CustomTable;
